import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgDocTextComponent, NgDocIconComponent, NgDocTextRightDirective, NgDocButtonComponent } from '@ng-doc/ui-kit';
let NgDocFullscreenButtonComponent = /*#__PURE__*/(() => {
  class NgDocFullscreenButtonComponent {
    static {
      this.ɵfac = function NgDocFullscreenButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocFullscreenButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocFullscreenButtonComponent,
        selectors: [["ng-doc-fullscreen-button"]],
        inputs: {
          route: "route"
        },
        decls: 4,
        vars: 1,
        consts: [["ng-doc-button-text", "", "target", "_blank", 3, "routerLink"], ["ng-doc-text", ""], ["icon", "external-link", "ngDocTextRight", ""]],
        template: function NgDocFullscreenButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "a", 0)(1, "span", 1);
            i0.ɵɵtext(2, " Open demo in a new tab ");
            i0.ɵɵelement(3, "ng-doc-icon", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("routerLink", ctx.route);
          }
        },
        dependencies: [RouterLink, NgDocTextComponent, NgDocIconComponent, NgDocTextRightDirective, NgDocButtonComponent],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:center;padding:calc(var(--ng-doc-base-gutter) * 2) calc(var(--ng-doc-base-gutter) * 2)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocFullscreenButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocFullscreenButtonComponent };
